var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-block"},[_c('div',{staticClass:"contents"},[_c('h2',{staticClass:"rectangle_label"},[_vm._v("お問い合わせ")]),_c('InquiryBox')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }